import Form from "react-bootstrap/Form";
// -
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import MiniQ2FormS from "./MiniQ2FormS";
import MiniQ2FormM from "./MiniQ2FormM";
import {useEffect, useState} from "react";

const MiniQ2Form = ({item}) => {
    const {t} = useCustomTranslation(translations);
    const [type, setType] = useState("s");

    useEffect(() => {
        if (item.id) {
            setType(item.type);
        }
    }, [item])

    const onChange = (e) => {
        setType(e.target.value);
    }
    const componentByType = () => {
        switch (type) {
            case "s":
                return <MiniQ2FormS item={item} t={t} type={type}/>
            case "m":
                return <MiniQ2FormM item={item} t={t} type={type}/>
            default:
                return <></>
        }
    }

    return <>
        <div className="col-md-3 col-12">
            <label htmlFor="type">{t("type")}</label>
            <Form.Select
                className="mb-2"
                id="type" name="type"
                value={type}
                style={{width: "120px"}}
                onChange={onChange}
            >
                <option value="s">{t("standalone")}</option>
                <option value="m">{t("multiple")}</option>
            </Form.Select>
        </div>
        {componentByType()}
    </>
}
export default MiniQ2Form